import { query, schema } from 'qman'
import { getShortlistById, getShortlists } from '../api/getters/shortlists'
import { documentFn, queryFn } from './schemaFunctions'

export const shortlists = schema(
  'shortlists',
  query('shortlistById', getShortlistById, documentFn),
  query('shortlists', getShortlists, queryFn)
)
